export default __webpack_public_path__ + "static/media/gitaar-2.7ac21114.jpg";